<div class="rx-card mt-4" [class.read-only]="isReadOnly$ | async">
	<div class="rx-card-title doctor-card-title">
		<div class="rx-title-row rx-app-flex-container-row rx-app-flex-container-row--justify-space-between">
			<div class="rx-app-flex--half">
				<rx-doctor-name class="rx-app-flex" [doctorName]="(doctor$ | async)?.Name"></rx-doctor-name>
			</div>
			<div *ngIf="(isLicenseEditable$ | async); then licenseEditor else licenseReadOnly"></div>
			<ng-template #licenseEditor>
				<div class="rx-app-flex--half">
					<rx-license-input [formControl]="licenseFormControl"></rx-license-input>
				</div>
			</ng-template>
			<ng-template #licenseReadOnly>
				<div class="rx-app-flex--half">
					<rx-license-read-only class="rx-app-flex" [license]="(license$ | async)"></rx-license-read-only>
				</div>
			</ng-template>
		</div>
	</div>
</div>
